import { lazy } from "react";

const CamilaMonitoring = lazy(() => import("./"));
const routes = [
  {
    path: "/dashboard/camila-monitoring",
    component: CamilaMonitoring,
    exact: true,
    name: "Monitoreo de Camila"
  }
];

export default routes;
